import PolicyPage from "@/components/shared/PolicyPage";
import { COMPANY, POLICY } from "@/config/company";

const sections = [
  {
    h: "Cancelling a booking",
    ul: [
      "You can cancel a booking before the shipment is picked up. Contact us on " + COMPANY.phone + " or " + COMPANY.email + " with your order number, or cancel from your account where the option is available.",
      "If the pickup has not happened and the shipment has not been handed to a carrier, the booking is cancelled without a cancellation charge.",
      "If a pickup agent has already travelled to collect the shipment, or the shipment has already been handed to a carrier, a cancellation or pickup charge may apply.",
      "Once a shipment has been picked up it can normally be stopped or returned only if the carrier allows it. Return and re-delivery charges, if any, are payable by the sender.",
    ],
  },
  {
    h: "Cancellation by us",
    p: ["We may cancel or refuse a booking if the goods are prohibited, the address or pincode is not serviceable or is found to be wrong, documents are missing or incorrect, or payment has not been completed. Where we cancel for these reasons, the amount you paid for the unused service is refunded as set out below."],
  },
  {
    h: "When you are entitled to a refund",
    ul: [
      "You paid but the booking was cancelled before pickup.",
      "You were charged twice for the same booking, or charged more than the amount shown at booking, apart from weight revisions explained in the Terms.",
      "We could not provide the service you paid for.",
    ],
  },
  {
    h: "How refunds are paid",
    ul: [
      "Wallet payments are refunded to your Sendtoo wallet.",
      `Online payments are refunded to the original payment method within ${POLICY.refundDays} of the refund being approved; your bank or card issuer may need additional time to show the credit.`,
      "Taxes charged on the cancelled service are reversed through a credit note as required by GST law.",
    ],
  },
  {
    h: "Weight and charge revisions",
    p: ["If the weight or dimensions measured by the carrier are different from those declared, the charge is revised. Where the measured weight is lower, the difference is credited to your wallet; where it is higher, the difference is debited."],
  },
  {
    h: "Lost or damaged shipments",
    p: ["Compensation for loss or damage is dealt with under the Terms & Conditions and the Shipping & Service Policy, and depends on the insurance or carrier-risk option chosen at booking."],
  },
  {
    h: "How to ask for a refund",
    p: [`Write to ${COMPANY.email} with your order or LR number and the reason. We will confirm whether the refund is approved and how long it will take.`],
  },
];

export default function RefundPolicy() {
  return <PolicyPage testId="refund-policy-page" title="Refund & Cancellation Policy" intro="This policy explains when a Sendtoo booking can be cancelled and when and how you get your money back." sections={sections} />;
}
